<template>
  <header class="auth-header">
    <div class="auth-header__logo">
      <v-img
        :src="logoSource"
        :alt="logoAltText"
        width="160"
        height="49"
        class="mx-auto"
        contain
      />
    </div>
    <h1 class="auth-header__title">
      {{ title }}
    </h1>
    <p class="auth-header__subtitle">
      {{ subtitle }}
    </p>
  </header>
</template>

<script setup lang="ts">
import { useAuthHeader } from './AuthHeader'

interface Props {
  title: string
  subtitle: string
  logoSrc?: string
  logoAlt?: string
}

const props = defineProps<Props>()

const { logoSource, logoAltText } = useAuthHeader(props)
</script>

<style scoped lang="scss" src="./AuthHeader.scss" />
